// extracted by mini-css-extract-plugin
export default {"pageWrap":"La-z","fullWidth":"Ma-z","heading":"Na-z","fullBleed":"Oa-z","hidden":"Pa-z"};